<template>
	<div>
		<layout-1
			:table_name="'Job Orders'"
			:filter_options=filters
			:id=pageid
			:searchbar=true
			:navbar=true
			:nav_items="['Add Job Order']"
			:nav_item_perms="['14']"
			:button_perm="'2'"
			:button_name="'Select'"
			:term=term
			:reroute="'/0300'"
			:select_reroute=true
			style="width:100%; height:calc(100vh - 50px);"
		></layout-1>
	</div>
</template>

<script>
import {PAGES} from './../../../constants.js'
import api from '@/api'
import router from '@/router/index'
export default {
    props: {
		term: ''
    },
	data(){
		return{
			pageid:PAGES.JOB_ORDERS_PAGE,
			filters:[
				{name:"LocalOffice"},
				{name:"Status", options:["Open","Completed","Cancelled","Internal"], value:[true,true,false,false], permission:['52','53','54','106']},
				{name:"Date", options:["Start","End"], value:['',''], permission:null},
				{name:"PONumberCount", options:["Not Empty","Empty"], value:[false,false], permission:null},
			]
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/view/Job_Orders.vue